import { TweenLite, gsap } from "gsap/all";

class SwitchDivs {
    constructor(selector, selectorContainer) {
        this.mainContainer = document.querySelector(selector);
        this.buttons = this.mainContainer.querySelectorAll("a[data-switch]");
        this.container = document.querySelector(selectorContainer);
        this.contents = this.container.querySelectorAll("div[data-switch]");

        this.buttons.forEach(button => {
            button.addEventListener("click", e => {
                var data = button.getAttribute("data-switch");
                this.toggleDropdown(e, data);
            });
        });
    }

    toggleDropdown(e, data) {
        e.preventDefault();
        e.stopPropagation();
        var dataButton = data;

        this.contents.forEach(content => {
            var dataContent = content.getAttribute("data-switch");

            if (dataContent == dataButton) this.openDropdown(content, data);

            if (dataContent != dataButton) this.closeDropdown(content, data);
        });
    }

    openDropdown(content, data) {
        content.classList.add("show");

        this.buttons.forEach(button => {
            if (button.getAttribute("data-switch") == data) {
                button.classList.add("button--selected");
            } else {
                button.classList.remove("button--selected");
            }
        });
    }

    closeDropdown(content, data) {
        content.classList.remove("show");
        this.buttons.forEach(button => {
            if (button.getAttribute("data-switch") == data) {
                button.classList.add("button--selected");
            } else {
                button.classList.remove("button--selected");
            }
        });
    }
}

export { SwitchDivs };
